import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { getLastResults, getDetailResults } from "../../../apiservices/CasionApi";
import RefResultModal from "../../casinoComponents/refResultModal";
import WorliResultBody from "../../casinoComponents/refResultModal/WorliResultBody";
import { formatRefMatchTime } from "../../../utils/refMatchTime";

/**
 * Last Result items in the reference markup (LastResultsSection):
 *   worli / worli2: every round is span.resultb "R"; click → loader overlay, then the result modal.
 *   worli3 (Matka): span.resultb with the market name (win). The reference opens a results calendar
 *   (Worli3Result, its own API) on click — not available here, so the item is display-only.
 */
export default function WorliResults({ gameType = "worli", fallbackTitle = "Worli Matka" }) {
  const apiType = String(gameType || "worli").toLowerCase().trim();
  const isMatka = apiType === "worli3";
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        const res = response?.data?.data?.res;
        if (Array.isArray(res)) setLastResults(res);
      } catch (e) {
        console.error("Error fetching last results:", e);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (mid) => {
    if (isMatka || loading || !mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, String(mid));
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (e) {
      console.error("Error fetching detail results:", e);
    }
    setLoading(false);
  };

  return (
    <>
      {lastResults.map((r, i) => (
        <span key={`${r?.mid}-${i}`} className="resultb" onClick={() => handleResultClick(r?.mid)}>
          {isMatka ? `\n        ${r?.win ?? ""}\n      ` : "\n        R\n      "}
        </span>
      ))}
      {!isMatka && (
        <>
          {loading && createPortal(<div className="loader-overlay" />, document.querySelector(".page-content") || document.body)}
          <RefResultModal
            show={showModal && !!detailResult}
            onHide={() => setShowModal(false)}
            title={`${detailResult?.ename || fallbackTitle} Result`}
            roundId={detailResult?.rid}
            matchTime={formatRefMatchTime(detailResult?.mtime)}
          >
            {detailResult && <WorliResultBody t1={detailResult} />}
          </RefResultModal>
        </>
      )}
    </>
  );
}
